import React, { useEffect, useState } from "react";
import {
  Table,
  Tbody,
  Tr,
  Td,
  Th,
  Button,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Flex,
  Spacer,
  IconButton,
  Checkbox,
  Box,
} from "@chakra-ui/react";
import useReceivingSector from "hooks/use-receiving";
import Select from "react-select";
import useGeneral from "hooks/use-general";
import useUser from "hooks/use-user";

import { BsPencil } from "react-icons/bs";
import { MdDisabledByDefault } from "react-icons/md";
import { DayOfWeek } from "./DayOfWeek";
import LoadingComponent from "components/Main/Loading";
import { Fornecedor } from "Interfaces/Providers/receivingSector";

const FornecedorTable: React.FC = () => {
  const {
    paramsData,
    postSupplierVagas,
    getSupplierVagas,
    editEntry,
    setEditEntry,
    dataUserSupplier,
    dataSupplier,
    loadingSupplier,
    getGPSupplier,
    loadingGPSupplier,
    newEntry,
    setNewEntry,
    putSupplierVagas,
    dataGPSupplier,
    editIdx,
    setEditIdx,
    loadingUpdate,
    deleteSupplierVagas,
  } = useReceivingSector();
  const { data: dataStore } = useGeneral();
  const { getSuppliers, suppliers } = useUser();

  const customStyles = {
    option: (provided: any, state: { isSelected: any }) => ({
      ...provided,
      borderBottom: "1px dotted pink",
      color: state.isSelected ? "black" : "black",
      padding: 20,
    }),
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  };

  const initialData: Fornecedor[] = [];

  const [data, setData] = useState(initialData);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [deleteId, setDeleteId] = useState<number | null>(null);

  // Handle Edit mode
  const handleEdit = (idx: number) => {
    setEditIdx(idx);
  };

  // Handle Save for editing or new entries
  const handleSave = () => {
    if (newEntry) {
      var objNewSupplierVagas = {
        storeId:
          paramsData[0] !== null && paramsData[0] !== undefined
            ? paramsData[0].storeId
            : 0,
        supplierId: newEntry.nome?.value,
        userSupplierId: newEntry.user?.value,
        receivingSectorId: newEntry.sector?.value,
        capacity: Number(newEntry.vagas),
        dayOfWeek: newEntry.diaSemana?.value,
        productManagerId: newEntry.gp?.value,
        active: true,
      };
      postSupplierVagas(
        objNewSupplierVagas,
        paramsData[0] !== null && paramsData[0] !== undefined
          ? paramsData[0].storeId
          : 0
      );
      // setNewEntry(null);
    } else if (editIdx !== null) {
      setEditIdx(null);
    }
  };

  const handleEditSave = () => {
    var dateSupply = dataSupplier.find((x) => x.id === editEntry.id);
    if (editEntry) {
      var objNewSupplierVagas = {
        storeId: dateSupply.storeId,
        supplierId: dateSupply.supplierId,
        userSupplierId: dateSupply.userSupplierId,
        receivingSectorId: dateSupply.receivingSectorId,
        capacity: Number(editEntry.vagas),
        dayOfWeek: dateSupply.dayOfWeek,
        productManagerId: dateSupply.productManagerId,
        active: editEntry.flag,
      };
      putSupplierVagas(
        objNewSupplierVagas,
        paramsData[0] !== null && paramsData[0] !== undefined
          ? paramsData[0].storeId
          : 0
      );
      setEditEntry(null);
      setEditIdx(null);
    } else if (editIdx !== null) {
      setEditIdx(null);
    }
  };

  // Handle input change for editing

  // Handle adding a new row
  const handleAddNew = () => {
    setNewEntry({
      id: 0,
      nome: "",
      vagas: 0,
      diaSemana: "",
      gp: "",
      user: "",
      sector: "",
      flag: false,
    });
  };

  // Handle delete with confirmation modal
  const handleDelete = (id: number) => {
    setDeleteId(id);
    onOpen();
  };

  const confirmDelete = () => {
    deleteSupplierVagas(
      deleteId,
      paramsData[0] !== null && paramsData[0] !== undefined
        ? paramsData[0].storeId
        : 0
    );
    onClose();
  };

  const parseValueSelect = (id: number) => {
    const valueOption = dataStore.find(
      (item: { value: number }) => item.value === id
    );
    return valueOption;
  };

  useEffect(() => {
    getSuppliers();
    getSupplierVagas(
      paramsData[0] !== null && paramsData[0] !== undefined
        ? paramsData[0].storeId
        : 0
    );
  }, []);

  const daysOfWeek = [
    { label: "Segunda-feira", value: 1 },
    { label: "Terça-feira", value: 2 },
    { label: "Quarta-feira", value: 3 },
    { label: "Quinta-feira", value: 4 },
    { label: "Sexta-feira", value: 5 },
  ];
  const sector = [
    { label: "Ferragem", value: 1 },
    { label: "Chaparia", value: 2 },
  ];

  return (
    <>
      <Flex
        direction={{ base: "column", md: "row" }}
        wrap="wrap"
        align="center"
        justify="space-between"
        mb={4}
      >
        <Select
          defaultValue={parseValueSelect(
            paramsData[0] !== null && paramsData[0] !== undefined
              ? paramsData[0].storeId
              : 0
          )}
          name="colors"
          isDisabled={true}
          options={dataStore}
          theme={(theme: { colors: any }) => ({
            ...theme,
            borderRadius: 0,
            colors: {
              ...theme.colors,
              text: "#6EB680",
              font: "#6EB680",
              primary25: "#6EB680",
              primary: "#6EB680",
              neutral80: "black",
              color: "black",
            },
          })}
          styles={customStyles}
          className="custom-select-supply "
          classNamePrefix="select"
        />
        <Spacer />
        <Button onClick={handleAddNew} mb={4} bg="green.100" color="white">
          Adicionar
        </Button>
      </Flex>
      {loadingSupplier ? (
        <>
          <LoadingComponent spinnerSize="40vh" />
        </>
      ) : (
        <>
          <Box overflowX="auto">
            <Table
              className="custom-table"
              variant="simple"
              color="gray.500"
              mb="24px"
              mt="12px"
              size="sm" // Opcional, reduz o tamanho para dispositivos menores
            >
              <thead>
                <Tr borderColor="gray.100" border="10px">
                  <Th color="black" textAlign="center" fontWeight="bold">
                    Fornecedor
                  </Th>
                  <Th color="black" textAlign="center" fontWeight="bold">
                    Usuario
                  </Th>
                  <Th color="black" textAlign="center" fontWeight="bold">
                    GP
                  </Th>
                  <Th color="black" textAlign="center" fontWeight="bold">
                    Setor
                  </Th>
                  <Th color="black" textAlign="center" fontWeight="bold">
                    Dia da Semana
                  </Th>
                  <Th
                    color="black"
                    textAlign="center"
                    fontWeight="bold"
                    w={200}
                  >
                    Vagas
                  </Th>

                  <Th color="black" textAlign="center" fontWeight="bold">
                    Ativo
                  </Th>
                  <Th color="black" textAlign="center" fontWeight="bold">
                    Ação
                  </Th>
                </Tr>
              </thead>
              <Tbody>
                {/* Linha para nova entrada */}
                {newEntry && (
                  <Tr>
                    <Td color="black">
                      <Select
                        name="colors-1"
                        // onChange={setSelectSupplier}
                        options={suppliers}
                        placeholder="Selecione o fornecedor..."
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        theme={(theme: { colors: any }) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            text: "#6EB680",
                            font: "#6EB680",
                            primary25: "#6EB680",
                            primary: "#6EB680",
                            neutral80: "black",
                            color: "black",
                          },
                        })}
                        styles={customStyles}
                        className="custom-select-supply "
                        classNamePrefix="select"
                        onChange={(e: any) => {
                          getGPSupplier(
                            paramsData[0] !== null &&
                              paramsData[0] !== undefined
                              ? paramsData[0].storeId
                              : 0,
                            e?.value
                          );
                          setNewEntry({
                            ...newEntry,
                            nome: e,
                            gp: "",
                            user: "",
                          });
                        }}
                      />
                    </Td>
                    <Td color="black">
                      <Select
                        name="colors-1"
                        // onChange={setSelectSupplier}
                        isDisabled={loadingGPSupplier}
                        options={dataUserSupplier}
                        value={newEntry.user}
                        placeholder="Selecione o Usuario..."
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        theme={(theme: { colors: any }) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            text: "#6EB680",
                            font: "#6EB680",
                            primary25: "#6EB680",
                            primary: "#6EB680",
                            neutral80: "black",
                            color: "black",
                          },
                        })}
                        styles={customStyles}
                        className="custom-select-supply "
                        classNamePrefix="select"
                        onChange={(e: {
                          target: { value: string | number };
                        }) => {
                          setNewEntry({ ...newEntry, user: e });
                        }}
                      />
                    </Td>
                    <Td color="black">
                      <Select
                        name="colors-1"
                        // onChange={setSelectSupplier}
                        isDisabled={loadingGPSupplier}
                        options={dataGPSupplier}
                        value={newEntry.gp}
                        placeholder="Selecione o GP..."
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        theme={(theme: { colors: any }) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            text: "#6EB680",
                            font: "#6EB680",
                            primary25: "#6EB680",
                            primary: "#6EB680",
                            neutral80: "black",
                            color: "black",
                          },
                        })}
                        styles={customStyles}
                        className="custom-select-supply "
                        classNamePrefix="select"
                        onChange={(e: {
                          target: { value: string | number };
                        }) => {
                          setNewEntry({ ...newEntry, gp: e });
                        }}
                      />
                    </Td>
                    <Td color="black">
                      <Select
                        name="colors-1"
                        // onChange={setSelectSupplier}
                        options={sector}
                        placeholder="Selecione o Setor..."
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        theme={(theme: { colors: any }) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            text: "#6EB680",
                            font: "#6EB680",
                            primary25: "#6EB680",
                            primary: "#6EB680",
                            neutral80: "black",
                            color: "black",
                          },
                        })}
                        styles={customStyles}
                        className="custom-select-supply "
                        classNamePrefix="select"
                        onChange={(e: {
                          target: { value: string | number };
                        }) => {
                          setNewEntry({ ...newEntry, sector: e });
                        }}
                      />
                    </Td>
                    <Td color="black">
                      <Select
                        name="colors"
                        options={daysOfWeek}
                        placeholder="Selecione o dia da semana..."
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        theme={(theme: { colors: any }) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            text: "#6EB680",
                            font: "#6EB680",
                            primary25: "#6EB680",
                            primary: "#6EB680",
                            neutral80: "black",
                            color: "black",
                          },
                        })}
                        styles={customStyles}
                        className="custom-select-supply "
                        classNamePrefix="select"
                        onChange={(e: any) => {
                          setNewEntry({ ...newEntry, diaSemana: e });
                        }}
                      />
                    </Td>
                    <Td color="black">
                      <Input
                        type="text"
                        onChange={(e) => {
                          setNewEntry({ ...newEntry, vagas: e.target.value });
                        }}
                        focusBorderColor="gray.300"
                        _focus={{ backgroundColor: "gray.100" }}
                      />
                    </Td>

                    <Td color="black">Sim</Td>
                    <Td color="black">
                      <>
                        {" "}
                        <Button
                          colorScheme="green"
                          disabled={
                            newEntry.diaSemana === "" ||
                            newEntry.gp === "" ||
                            newEntry.nome === "" ||
                            newEntry.vagas === "" ||
                            Number(newEntry.vagas) === 0 ||
                            loadingUpdate
                          }
                          onClick={() => handleSave()}
                        >
                          Salvar
                        </Button>
                        <Button
                          variant="ghost"
                          onClick={() => {
                            setNewEntry(null);
                          }}
                        >
                          Fechar
                        </Button>
                      </>
                    </Td>
                  </Tr>
                )}
                {dataSupplier.map((item, idx) => (
                  <Tr key={item.id}>
                    <Td color="black">
                      {item.supplierId + " - " + item.supplierName}
                    </Td>
                    <Td color="black">{item.userSupplierName}</Td>
                    <Td color="black">{item.productManagerName}</Td>
                    <Td color="black">{item.receivingSectorName}</Td>
                    <Td color="black">
                      {
                        daysOfWeek.find((day) => day.value === item.dayOfWeek)
                          .label
                      }
                    </Td>
                    <Td color="black">
                      {editIdx === idx ? (
                        <Input
                          value={editEntry.vagas}
                          type="number"
                          onChange={(e) => {
                            setEditEntry({
                              ...editEntry,
                              vagas: e.target.value,
                            });
                          }}
                          focusBorderColor="gray.300"
                          _focus={{ backgroundColor: "gray.100" }}
                        />
                      ) : (
                        item.capacity
                      )}
                    </Td>

                    <Td color="black">
                      {editIdx === idx ? (
                        <Checkbox
                          isChecked={editEntry.flag}
                          onChange={(e) => {
                            setEditEntry({
                              ...editEntry,
                              flag: e.target.checked,
                            });
                          }}
                        >
                          Ativo
                        </Checkbox>
                      ) : item.active ? (
                        "Sim"
                      ) : (
                        "Não"
                      )}
                    </Td>
                    <Td color="black">
                      {editIdx === idx ? (
                        <>
                          <Button
                            colorScheme="green"
                            onClick={() => handleEditSave()}
                            disabled={
                              Number(editEntry.vagas) === 0 || loadingUpdate
                            }
                          >
                            Salvar
                          </Button>
                          <Button
                            variant="ghost"
                            onClick={() => {
                              setEditEntry(null);
                              setEditIdx(null);
                            }}
                          >
                            Fechar
                          </Button>
                        </>
                      ) : (
                        <>
                          <IconButton
                            ml={2}
                            icon={<BsPencil />}
                            aria-label="Editar"
                            variant="outline"
                            size="sm"
                            colorScheme="teal"
                            onClick={() => {
                              setEditEntry({
                                id: item.id,
                                nome: "",
                                vagas: item.capacity,
                                diaSemana: "",
                                sector: "",
                                gp: "",
                                user: "",
                                flag: item.active,
                              });
                              handleEdit(idx);
                            }}
                            marginRight={2}
                          />
                          <IconButton
                            icon={<MdDisabledByDefault />}
                            aria-label="Excluir"
                            variant="outline"
                            size="sm"
                            colorScheme={"red"}
                            cursor="pointer"
                            onClick={() => {
                              handleDelete(item.id);
                            }}
                          />
                          {/* <Button onClick={() => handleEdit(idx)} mr={2}>
                      Editar
                    </Button>
                    <Button
                      colorScheme="red"
                      onClick={() => handleDelete(item.id)}
                    >
                      Excluir
                    </Button> */}
                        </>
                      )}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
        </>
      )}

      {/* Modal de confirmação de exclusão */}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Confirmação</ModalHeader>
          <ModalCloseButton />
          <ModalBody>Tem certeza que deseja excluir este fornecedor?</ModalBody>
          <ModalFooter>
            <Button colorScheme="red" onClick={confirmDelete}>
              Excluir
            </Button>
            <Button ml={3} onClick={onClose}>
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default FornecedorTable;
